import { render, staticRenderFns } from "./editSeed.vue?vue&type=template&id=64150477&"
import script from "./editSeed.vue?vue&type=script&lang=js&"
export * from "./editSeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports